var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-icon" },
    [
      _c("div", {
        class: [
          "category-card__icon-hover",
          "category-card__icon-hover--" + _vm.backgroundPosition
        ]
      }),
      _vm._v(" "),
      _c("v-icon", {
        staticClass: "category-card__icon",
        attrs: { name: _vm.iconName }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }